module.exports = __webpack_public_path__ + "img/face-laugh.b8efe819.svg";